import { colors, fade, makeStyles, Theme } from "@material-ui/core";

export const useFunctionStyles = makeStyles((theme: Theme) => ({
  content: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
  },
  header: {
    display: "flex",
    flex: "0 1 auto",
    height: 70,
  },
  formControl: {
    marginTop: 10,
    marginBottom: 10,
  },
  actions: {
    justifyContent: "flex-end",
  },
  widget: {},
  widgets: {
    overflowY: "auto",
    paddingTop: 1,
    margin: 0,
  },
  inputComponent: {
    padding: "0 6px",
  },
  createFunctionButton: {
    color: theme.palette.common.white,
    backgroundColor: colors.green[600],
    "&:hover": {
      backgroundColor: colors.green[900],
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: colors.green[600],
      },
    },
    "&[disabled]": {
      backgroundColor: "transparent",
    },
  },
  deleteFunctionButton: {
    color: colors.red[600],
    border: `1px solid ${fade(colors.red[600], 0.5)}`,
    "&:hover": {
      border: `1px solid ${colors.red[600]}`,
      backgroundColor: fade(colors.red[600], theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent",
      },
    },
  },
  closeIconAction: {
    "&:hover": {
      cursor: "pointer",
    },
    margin: 0,
  },
  bold: {
    fontWeight: 550,
  },
  linkIcon: {
    color: "#3f51b5",
    textDecoration: "none",
    fontSize: 12,
    marginRight: theme.spacing(0.5),
    position: "relative",
    top: 2,
  },
  link: {
    marginBottom: theme.spacing(2),
    textAlign: "left",
    color: "#222",
    wordBreak: "break-all",
    "& a": {
      fontSize: "14px",
      "&, &:link, &:visited, &:hover": {
        color: "#3f51b5",
        textDecoration: "none",
      },
      "&:hover": {
        textDecoration: "underline",
      },
    },
  },
  monospaceText: {
    fontFamily: "monospace",
  },
}));

export const useModalStyles = makeStyles((theme) => ({
  root: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    outline: "none",
    boxShadow: theme.shadows[20],
    width: 500,
    maxHeight: "100%",
    overflowY: "auto",
    maxWidth: "100%",
  },
  container: {
    marginTop: theme.spacing(3),
    height: 200,
  },
  actions: {
    justifyContent: "flex-end",
  },
  inputField: {
    marginTop: 16,
  },
  deactivateButton: {
    color: theme.palette.common.white,
    backgroundColor: colors.red[600],
    "&:hover": {
      backgroundColor: colors.red[900],
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: colors.red[600],
      },
    },
  },
  closeIconAction: {
    "&:hover": {
      cursor: "pointer",
    },
    margin: 0,
  },
  bold: {
    fontWeight: 550,
  },
  acceptButton: {
    color: theme.palette.common.white,
    backgroundColor: colors.green[600],
    "&:hover": {
      backgroundColor: colors.green[900],
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: colors.green[600],
      },
    },
  },
}));
